<template>
  <component
    :is="component"
    v-if="component"
    v-bind="props"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const props = defineProps({
  placeholder: {
    type: String,
    required: true
  },
  id: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  adType: {
    type: String,
    required: true,
    default: null
  },
  showOnDesktop: {
    type: Boolean,
    required: false,
    default: false
  },
  showOnMobile: {
    type: Boolean,
    required: false,
    default: false
  }
});

const componentMap: {[key: string]: string} = {};

const component = shallowRef(null);
component.value = defineAsyncComponent(async () => {
  const componentName = componentMap[props.adType];
  if (componentName) {
    try {
      return await import(`~/components/${componentName}/${componentName}.vue`);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(`Component ${componentName} not implemented`, e);
      return null;
    }
  }
});
</script>
